import { AssetRequestStatus } from '@atom/types/assetRequest';

import { STATUS_COLORS, STATUS_LABELS } from '../assetRequestConstants';

import classes from './requestsTable.module.css';

interface Props {
  status: AssetRequestStatus;
}

const RequestStatusPill = ({ status }: Props) => {
  const pillStyle = {
    backgroundColor: STATUS_COLORS[status] || '#FFF',
  };

  return (
    <span style={pillStyle} className={classes.statusPill}>
      {STATUS_LABELS[status] || ''}
    </span>
  );
};

export default RequestStatusPill;
